import { useEffect } from "react";

/** Relâche tout verrou de défilement orphelin (Radix / react-remove-scroll) dès qu'aucune modale n'est ouverte — iter155 P5. */
export default function ScrollLockWatchdog() {
  useEffect(() => {
    const body = document.body;
    const anyOpen = () => !!document.querySelector('[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"], [data-radix-popper-content-wrapper], [data-desk-modal]');
    const release = () => {
      if (anyOpen()) return;
      if (body.style.pointerEvents) body.style.pointerEvents = "";
      if (body.style.overflow === "hidden") body.style.overflow = "";
      if (body.style.paddingRight) body.style.paddingRight = "";
      if (body.hasAttribute("data-scroll-locked")) body.removeAttribute("data-scroll-locked");
      if (document.documentElement.style.overflow === "hidden") document.documentElement.style.overflow = "";
    };
    let raf = 0;
    const schedule = () => { if (raf) return; raf = requestAnimationFrame(() => { raf = 0; setTimeout(release, 50); }); };
    const mo = new MutationObserver(schedule);
    mo.observe(body, { childList: true, subtree: true, attributes: true, attributeFilter: ["style", "data-state", "data-scroll-locked"] });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") schedule(); });
    return () => { mo.disconnect(); if (raf) cancelAnimationFrame(raf); };
  }, []);
  return null;
}
